import { request } from "../components/request";
import { CSRF_TOKEN } from "../constants";

export class Api {
	getPrices(event_id, view_id) {
		return request("/event/get-prices", {
			event_id,
			view_id,
		});
	}

	getCartCount(event_id = 0) {
		return request(
			`/event/cart/get-cart`,
			{ "_csrf-frontend": CSRF_TOKEN, event_id },
			"POST",
			true,
			false,
		);
	}

	getSubscriptionCartCount(event_id, sub_event_id, needOverlay = false) {
		return request(
			`/subscription-cart/get-cart/${event_id}/${sub_event_id}`,
			null,
			"POST",
			true,
			needOverlay,
		);
	}

	addToSubscriptionCart(event_id, sub_event_id, sid) {
		return request(`/subscription-cart/add-to-cart/${event_id}/${sub_event_id}`, {
			sid,
		});
	}

	removeFromSubscriptionCart(event_id, sub_event_id, sid) {
		return request(`/subscription-cart/remove-from-cart/${event_id}/${sub_event_id}`, {
			sid,
		});
	}

	addEvent(event_id, sub_event_id) {
		return request(`/subscription-cart/add-event/${event_id}/${sub_event_id}`);
	}

	removeEvent(event_id, sub_event_id) {
		return request(`/subscription-cart/remove-event/${event_id}/${sub_event_id}`);
	}

	addAllEvents(event_id) {
		return request(`/subscription-cart/add-events/${event_id}`);
	}

	removeAllEvents(event_id) {
		return request(`/subscription-cart/remove-events/${event_id}`);
	}

	removeEventSids(event_id, sub_event_id) {
		return request(`/subscription-cart/remove-event-sids/${event_id}/${sub_event_id}`);
	}

	getPlaces(event_id) {
		return request(
			"/event/get-places",
			{
				event_id,
			},
			"GET",
		);
	}

	getPlacesSvg(event_id, view_id) {
		return request(
			"/event/get-svg",
			{
				event_id,
				view_id,
			},
			"POST",
		);
	}

	getSubscriptionChange(event_id, name) {
		return request(
			`/subscription/change/`,
			{
				event_id,
				name,
			},
			"GET",
			false,
		);
	}

	getChangeSeats(event_id, sub_event_id) {
		return request(`/subscription-cart/move-event-carts/${event_id}/${sub_event_id}`);
	}
}
